// @givmo/employer-module — Reports (EP-DES2 Wave 0 → EP-WEB7 → EP-WEB26, the redesign).
//
// ONE destination for everything a company hands to finance, laid out by who opens it and why:
//
//   - the REPORTS, as tiles at the top (EP-WEB26, Jonathan's direction and rulings of 2026-09-29) —
//     Tax documents first (the annual reports, and the tax lines spreadsheet for a chosen year), then
//     the year recap and the Impact, Enrollment and Transactions exports. Each tile does one real
//     thing — download, view, or open — and Tax documents adds the spreadsheet.
//   - the RECAP below them: the year's giving told as a story an HR lead can take to leadership —
//     the total and what it is made of, the program's reach, where the money went and when.
//   - the TAX DOCUMENTS in the employer portal: the annual-report PDFs (generate, list, download),
//     absorbed here from the retired `/documents` page. In the company console they are the
//     Organization's own page (EP-MNT4, the Reports split), so the tile OPENS them there instead.
//     The host's address book says which (`taxDocuments`: `null` in the portal, a door in the console).
//
// Nothing here is decorative: no placeholder section, no disabled tile, no "coming soon" (§5).
//
// Routing: `/documents` and `/reporting` both redirect here (routes.tsx), so old bookmarks and
// post-login `redirect` targets resolve instead of 404ing. The dashboard's Export menu deep-links the
// tiles (`#exports`) and the recap (`#recap`).

import { PageHeader, testIdProp } from '@givmo/design-system';
import { useEmployerModulePaths } from '../../lib/module-paths';
import { TaxDocumentsSection } from '../documents/documents-page';
import { ExportsSection } from './exports-section';
import { RecapSection } from './recap-section';

export function ReportsPage() {
  const { taxDocuments } = useEmployerModulePaths();
  return (
    <div
      className="mx-auto flex w-full max-w-[1280px] flex-col gap-24 px-24 py-24"
      {...testIdProp('page-reports')}
    >
      <PageHeader
        title="Reports"
        subtitle="Your company's giving, in a form you can hand to finance."
      />

      <ExportsSection />

      <RecapSection />

      {taxDocuments === null ? <TaxDocumentsSection /> : null}
    </div>
  );
}
